import React from "react";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import { useStyles } from "./styles";

export default function Step5ServicesCatalog({ services, addService, removeService, updateService }) {
  const c = useStyles();
  return (
    <>
      <Typography variant="h6" gutterBottom>Catálogo de servicios</Typography>
      {services.map((s, idx) => (
        <div key={idx} className={c.inlineRow}>
          <TextField size="small" label="Servicio" value={s.serviceName} onChange={(e) => updateService(idx, "serviceName", e.target.value)} style={{ minWidth: 140 }} />
          <TextField size="small" label="Duración (min)" type="number" value={s.durationMin ?? 60} onChange={(e) => updateService(idx, "durationMin", +e.target.value || 60)} style={{ width: 90 }} />
          <TextField size="small" label="Precio" type="number" value={s.price ?? 0} onChange={(e) => updateService(idx, "price", +e.target.value || 0)} style={{ width: 90 }} />
          <FormControlLabel control={<Checkbox checked={!!s.requiresProfessional} onChange={(e) => updateService(idx, "requiresProfessional", e.target.checked)} />} label="Requiere profesional" />
          <IconButton size="small" onClick={() => removeService(idx)} disabled={services.length <= 1}><DeleteIcon /></IconButton>
        </div>
      ))}
      <Button startIcon={<AddIcon />} onClick={addService} color="primary">Agregar servicio</Button>
    </>
  );
}
